import { render, staticRenderFns } from "./BscFileInfo.vue?vue&type=template&id=ec156414"
import script from "./BscFileInfo.vue?vue&type=script&lang=js"
export * from "./BscFileInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports